module.exports = __webpack_public_path__ + "static/media/services-img4.2e0d3db7.jpg";